import { render, staticRenderFns } from "./CarBrands.vue?vue&type=template&id=0fb74108"
import script from "./CarBrands.vue?vue&type=script&lang=js"
export * from "./CarBrands.vue?vue&type=script&lang=js"
import style0 from "./CarBrands.vue?vue&type=style&index=0&id=0fb74108&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports